import RoutesContainer from './ui/containers/RoutesContainer';
import React from "react";

function App() {
  return <RoutesContainer />;
}

export default App;
